import React, {useState, useRef} from 'react';
import { Link , useLocation, useHistory } from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../../../layout/LayoutAside";
import Button from 'components/buttons/';
import UIInput from 'components/input/input';
import CommonUtil from 'utils/CommonUtil';
import DateUtil from "utils/DateUtil";
import UIUtils from "utils/UIUtils";
import icon from 'assets/img/icon/ic_file_add.svg';
import ibsheet from "../../../example/ibsheet";
import StringUtil from "../../../../utils/StringUtil";


function ContentsContainer() {
    const location = useLocation();
    let receivedData = (location.state as any)?.data;
    const history = useHistory();

    const [totalRowCnt,setTotalRowCnt] = useState(0);
    const [showRowCnt,setShowRowCnt] = useState(20); //기본 row count
    const [notiTitle,setNotiTitle] = useState('');
    const [notiDivCd, setNotiDivCd] = useState('');
    const [notiTpCd, setNotiTpCd] = useState('N');

    //검색조건 저장용
    let searchParams = useRef<any>({});

    //초기 데이터 설정
    let totalCnt = useRef<number>(0);
    let defaultRowCnt = 20;
    let rowCnt = useRef<number>(20);
    let pageNum = useRef<number>(1)

    //====== 그리드 공통 부 START
    var ib = ib||{};
    // @ts-ignore
    ib = {
        //시트 초기화 구문
        'init':{
            "Cfg": {
                "SearchMode": 1,
                "PageLength": defaultRowCnt,
                "InfoRowConfig": "0",
                "Alternate": "0",
                "Height": "auto",
                "MessageWidth": 300,
                "AutoRowHeight": true
            },
            "Def": {
                "Row": {
                    CanFormula: true,
                    CalcOrder: "NOTI_TITLE,FILE,HtmlPostfixFormula",
                    Spanned: 1,
                }
            },
                //틀고정 좌측 컬럼 설정
                "LeftCols": [
                {"Header": "No","Name": "SEQ","Width": "90"}
                ],
            "Cols": [
                {"Header": "게시글번호","Type": "Text","NOTI_NO": "","RelWidth": 1.5,"Align": "Center" ,"CanEdit": "0"},
                {"Header": "No","Type": "Int", "Name": "SEQ","Align": "Center","RelWidth": 1,"CanEdit": "0"},
                {"Header": "구분","Type": "Text","Name": "NOTI_DIV_CD","RelWidth": 1,"Align": "Center","CanEdit": "0"},
                {
                    "Header": "제목",
                    "Type": "Html",
                    "Name": "NOTI_TITLE",
                    "RelWidth": 5,
                    "Align": "left"
                    ,"CanEdit": "1"
                    ,"Formula" : function(fr){
                        if(fr.Row["FILE_YN"] === 'Y') {
                            return fr.Row["NOTI_TITLE"] + '<image src=\'/external/ibsheet/img/ic_file_add.svg\'></image>';
                        }else {
                            return fr.Row["NOTI_TITLE"]
                        }
                    }
                },
                {"Header": "첨부","Type": "Html","Name": "FILE","RelWidth": 2,"Align": "Center" , "HtmlPostfix" : "<img src='/external/ibsheet/img/ic_file_add.svg'>", "Visible" : 0},
                {"Header": "게시상태","Type": "Text","Name": "NOTI_STS_CD","RelWidth": 1,"Align": "Center","CanEdit": "0"},
                {"Header": "조회수","Type": "Int","Name": "RET_CNT","RelWidth": 1,"Align": "Center","CanEdit": "0"},
                {"Header": "등록자","Type": "Text","Name": "REG_USER_NM","RelWidth": 1,"Align": "Center","CanEdit": "0"},
                {"Header": "등록일","Type": "Text","Name": "REG_DATE","RelWidth": 1,"Align": "Center","CanEdit": "0"}
            ]
        },
        //시트 이벤트
        'event':{
            onRenderFirstFinish:function (evtParam) {
                if(receivedData == undefined){
                    //초기 데이터 로딩
                    doSearch('init','');
                }else{
                    if(JSON.stringify(receivedData.searchData) == '{}'){
                        doSearch('init','');
                    }
                }
            },
            onRenderFinish : function(evtParam){
                if(receivedData !=undefined ){
                    if(receivedData.searchPageNum != undefined){  //페이지 번호가 있으면 모든 렌더링이 끝나고 다시 페이지 이동처리
                        pageMove(receivedData.searchPageNum);
                    }
                }
            },
            // 클릭 이벤트
            onAfterClick: function(evtParam:React.ChangeEvent<HTMLInputElement>) {
                // @ts-ignore
                let row = sheet.getFocusedRow();

                let searchData = searchParams.current;
                if(JSON.stringify(searchData) == '{}'){
                    if(receivedData != undefined){
                        searchData = receivedData.searchData;
                    }
                }

                let searchPageNum = pageNum.current;
                let NOTI_NO = row["NOTI_NO"];
                let dataToSend = {searchData, searchPageNum, NOTI_NO};

                history.push({
                  pathname: './adm5110',
                  state: { data: dataToSend }
                });
            },
            onBeforeDataLoad:function (evtParam) {
                // 조회 후 로딩 전 발생 이벤트
                var d = evtParam.data;
                var _data;

                // 서버에서 가져온 데이터를 "데이터" 텝에 넣어준다.
                if (d.length > 20) { // 최대 20개 행만 텝에 넣어 주자(많아지면 화면이 엄청 느려질 수 있음)
                _data = JSON.stringify(d.slice(0, 20), null, 2);
                _data += _data.substring(0, _data.length - 1) + '...\n]';
                } else {
                _data = JSON.stringify(d, null, 2);
                }

            },
            //데이터 로딩 후 이벤트 처리
            onDataLoad:function (evtParam) {
            },
            onAfterGotoPage:function (evtParam) {

                var sheet = evtParam.sheet;
                var page = sheet.getPageIndex(sheet.getFocusedPage()) + 1;
                //@ts-ignore
                if (currentPage != -1 && currentPage != page) {
                  makePageIndex(page);
                }

            }
        },
        //시트객체 생성
        'create':function () {
            let options = this.init;

            //@ts-ignore
            options.Events = this.event;
            //@ts-ignore
            IBSheet.create({
                id: 'sheet', // 생성할 시트의 id
                el: 'sheetDiv', // 시트를 생성할 Dom 객체 및 id
                options: options, // 생성될 시트의 속성
                data: this.data // 생성될 시트의 정적데이터
            });
            // global 변수 선언
            //@ts-ignore
            window.currentPage = -1;
        },
        //엑셀 다운로드
        'exportData':function () {
            let today:string = DateUtil.currentDateFormat("YYYYMMDD");
            //@ts-ignore
            IBSheet.sheet.down2Excel({fileName: "공지사항_"+today+".xlsx", SheetDesign:1, downCols: "Visible"});
        },
        //조회 데이터
        'data':[]
    }

    //====== 그리드 공통 부  END


    const handleSelect = (e) => {
        if(e.target.name === 'notiDivCd'){
            if(e.target.value === '0'){
                setNotiDivCd('');
            } else {
                setNotiDivCd(e.target.value);
            }
        } else if(e.target.name === 'showRowCnt'){
            setShowRowCnt(e.target.value);

            rowCnt = e.target.value;
            // @ts-ignore
            IBSheet.disposeAll(true);
            ib.init.Cfg.PageLength = e.target.value;
            ib.create();
        }
    };

    React.useEffect(() => {

        //ib시트 생성
        ib.create();

        if(receivedData != undefined){
            if(receivedData.searchData.NOTI_DIV_CD != undefined){
                setNotiDivCd(StringUtil.defaultString(receivedData.searchData.NOTI_DIV_CD));
            }
            if(receivedData.searchData.NOTI_TP_CD != undefined){
                setNotiTpCd(StringUtil.defaultString(receivedData.searchData.NOTI_TP_CD));
            }
            if(receivedData.searchData.NOTI_TITLE != undefined){
                setNotiTitle(StringUtil.defaultString(receivedData.searchData.NOTI_TITLE));
            }

            //상세데이터 가지고 오기
            doSearch('search' , receivedData.searchData);
        }


        return () => {
          // @ts-ignore
          IBSheet.disposeAll(true);
        }
    },[])


    //====== 그리드 데이터 가지고 오기  START
    async function doSearch(sAction:string, searchData:any) {
        let param = {};

        //검색데이터가 있으면 검색데이터로 처리
        if(searchData != ''){
            param = searchData;
        }else {
            if (sAction == 'search') {
                param = {
                    NOTI_TP_CD: notiTpCd,
                    NOTI_TITLE: notiTitle,
                    NOTI_DIV_CD : notiDivCd
                };
            } else {
                param = {
                    NOTI_TP_CD: notiTpCd,
                };
            }

            //검색조건을 해당 페이지에 다시 넣어준다.
            searchParams.current = param;
            let searchData = searchParams.current;
            let searchPageNum = 1;   //조회시는 무조건 페이지 번호는 1
            let dataToSend = { searchData , searchPageNum}

            history.push({ pathname: './adm5100', state: { data: dataToSend }});

            receivedData = dataToSend;  //검색조건을 다시 넣어준다.
        }




        const response:any = await CommonUtil.execute({
            url: 'adm_5100.jct',
            data: param
        });

        let result = response.REC;

        if(result.length > 0){
            //전체ROW개수
            totalCnt.current = result.length;
            setTotalRowCnt(Object.keys(response.REC).length);
        }

        //데이터 처리
        ib.data = result;

        // @ts-ignore
        sheet.loadSearchData(result);  //data 로딩 처리
        // @ts-ignore
        sheet.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함
        // @ts-ignore
        makePageIndex(sheet.getPageIndex( sheet.getFocusedPage()) + 1); // 페이지 초기화

    }

    //====== 그리드 데이터 가지고 오기  END

    //====== 그리드 페이징 처리
    // @ts-ignore
    const makePageIndex = function (tp:number) {
      try {
        if (tp == null) {
            //@ts-ignore
            currentPage = -1;
            return;
        }

        // @ts-ignore
        if (document.getElementById('pageNavi').firstChild) {
          // @ts-ignore
          document.getElementById('pageNavi').removeChild(document.getElementById('pageNavi').firstChild);
        }

        // @ts-ignore
        currentPage = tp;
        // @ts-ignore
        let sr = sheet.getTotalRowCount(); // 전체 조회 건수
        // @ts-ignore
        let page = sheet.PageLength; // 페이지당 레코드 수
        let thispage = tp; // 현재 페이지
        let pagecnt = 5; // 한번에 표시할 페이지 개수
        let lastpage = Math.ceil(sr / page); // 마지막 페이지 인덱스
        let li, tt, a;
        let ul = document.createElement('DIV');
        // @ts-ignore
        ul.style.textAlign = 'center';

        let k = 1;

        if (thispage !== 1) {
          let ul_sub = document.createElement('DIV');
          ul_sub.className ="group";
          li = document.createElement('Button');
          li.className = 'item first';
          a = document.createElement('a');
          a.style.cursor = 'pointer';
          tt = document.createTextNode('<<');
          addEventHandler(li, 'click', pageMove, 1);
          a.appendChild(tt);
          li.appendChild(a);
          ul_sub.appendChild(li)
          ul.appendChild(ul_sub);

          li = document.createElement('Button');
          li.className = 'item prev';
          a = document.createElement('a');
          a.style.cursor = 'pointer';
          addEventHandler(li, 'click', pageMove, tp - 1);
          tt = document.createTextNode('<');
          a.appendChild(tt);
          li.appendChild(a);
          ul_sub.appendChild(li)
          ul.appendChild(ul_sub);
        }

        sr = (Math.ceil(tp / pagecnt) * pagecnt) - (pagecnt - 1);
        let ul_sub2 = document.createElement('DIV');
        ul_sub2.className ="group";
        for (let i = sr; i < (sr + pagecnt); i++) {
          if (i <= lastpage) {
            li = document.createElement('Button');
            li.className ="item";
            a = document.createElement('a');
            a.style.cursor = 'pointer';
            tt = document.createTextNode(String(i));
            addEventHandler(li, 'click', pageMove, i);
            if (i === tp) {
              li.className ="item active";
            }
            a.appendChild(tt);
            li.appendChild(a);
            ul_sub2.appendChild(li);
            ul.appendChild(ul_sub2);
          }
        }

        if (thispage < lastpage) {
          let ul_sub3 = document.createElement('DIV');
          ul_sub3.className ="group";
          a = document.createElement('a');
          a.style.cursor = 'pointer';
          li = document.createElement('Button');
          li.className = 'item next';
          tt = document.createTextNode('>');
          addEventHandler(li, 'click', pageMove, tp + 1);
          a.appendChild(tt);
          li.appendChild(a);
          ul_sub3.appendChild(li);
          ul.appendChild(ul_sub3);

          li = document.createElement('Button');
          li.className = 'item last';
          tt = document.createTextNode('>>');
          a = document.createElement('a');
          a.style.cursor = 'pointer';
          addEventHandler(li, 'click', pageMove, lastpage);
          a.appendChild(tt);
          li.appendChild(a);
          ul_sub3.appendChild(li);
          ul.appendChild(ul_sub3);
        }

        ul.className = 'pg';
        // @ts-ignore
        document.getElementById('pageNavi').appendChild(ul);
      } catch (ex) {
        // @ts-ignore
        alert(ex.message);
      }
    }

    //페이지 이동
    // @ts-ignore
    const pageMove = function (cPage:number) {
      // @ts-ignore
      sheet.goToPageByIndex(cPage);

    }

    //페이지 이동 이벤트 핸들러
    // @ts-ignore
    const addEventHandler = function (obj, evtName, func, param) {
      if (obj.addEventListener) { // all browsers except IE before version 9
        obj.addEventListener(evtName, function () { func(param); }, false);
      } else if (obj.attachEvent) { // IE before version 9
        obj.attachEvent('on' + evtName, function () { func(param); });
      }
    }

    // 등록 페이지로 이동
    const onClickReg = function () {
        let dataToSend = {};
        // 다른 페이지로 이동하면서 데이터 전달
        history.push({
          pathname: './adm5120',
          state: { data: dataToSend }
        });

    };

    //인풋 엔터체크
    const activeEnter = (e) => {
        if(e.key === "Enter") {
            doSearch('search','');
        }
    }

    // 제목 텍스트 입력 후 엔터 시 리로딩 방지
    const submitHnadler = (e) => {
        e.preventDefault();
    }


	return (
		<PageContainer>
			<LayoutAside />
			<div className="fww-con">
				<ul className="fww-brd">
					<li><Link to="/admin/">홈</Link></li>
					<li><Link to="#">관리자페이지</Link></li>
					<li><Link to="#">게시판관리</Link></li>
					<li><Link to="#">공지사항</Link></li>
				</ul>
				<main className="fww-main">
					<h1 className="tx tx-hd2">공지사항</h1>
					<form className="sf sf-1row" name="" action="" method="" onSubmit={submitHnadler}>
						<div className="inner">
							<div className="sf-item">
								<p className="sf-key">구분</p>
								<div className="sf-value">
									<div className="sl sl-md">
										<select name="notiDivCd" id="notiDivCd" className="" onChange={handleSelect}>
											<option value="0">전체</option>
											<option value="1">공통공지</option>
											<option value="2">주요자료</option>
											<option value="3">사업공지</option>
										</select>
									</div>
								</div>
							</div>
							<div className="sf-item sf-m-2-4">
								<p className="sf-key">제목</p>
								<div className="sf-value">
									<UIInput  className={'tf tf-md w100p'} value={notiTitle} valueChanged={(value) => setNotiTitle(value)} onKeyEnter={(e) => activeEnter(e)}/>
								</div>
							</div>
						</div>
						<Button color="pri" size="md" onClick={()=> doSearch('search','')}>조회</Button>
					</form>
					<div className="tb-top">
						<div>
							<p className="tx fc-black"></p>총 <em className="fw500">{totalRowCnt}</em>건
						</div>
                        <div className="hz-root hz-gap5">
                            <Button color="pri-o" size="sm" onClick={() => onClickReg()}>등록</Button>
                            <Button color="gray-o" size="sm" onClick={() => ib.exportData()}>다운로드</Button>
                            <div className="sl sl-sm w120">
                                <select name="showRowCnt" id="showRowCnt" value={showRowCnt} onChange={(handleSelect)}>
                                    <option value="20">20개씩보기</option>
                                    <option value="50">50개씩보기</option>
                                    <option value="100">100개씩보기</option>
                                    <option value="200">200개씩보기</option>
                                    <option value="500">500개씩보기</option>
                                    <option value="1000">1000개씩보기</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div id='sheetDiv'>[D] IBSHEET 영역
                        <button className="btn-file" type="button">첨부파일</button>
                    </div>
                    <div id="pageNavi" className="pg">
                    </div>
				</main>
			</div>
		</PageContainer>
	);
}
export default ContentsContainer;